module.exports = __webpack_public_path__ + "static/media/DPL_03.02381c1f.jpg";